export interface CloneDecisionTreeVersion {
    destination_tree_id: string;
    include_definition: boolean;
    id: string;
  }